import { Container, Box, Grid, Button, useTheme, useMediaQuery } from "@material-ui/core";
import { reviews, supportReviews, ReviewView, solarReviews } from "../../components/Review";
import { sliderSettings } from "../../components/Slider";
import Slider from "react-slick";
import { EQuoteType } from "../../api/Types";
import { TF } from "../../components/typography/TF";

export const ReviewContainer = ({ type, support }: Props) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  let items = reviews();

  if (type) {
    switch (type) {
      case EQuoteType.Boiler:
        items = reviews();
        break;
      case EQuoteType.Solar:
      case EQuoteType.BoilerSolar:
        items = solarReviews();
        break;
    }
  }

  if (support) {
    items = supportReviews();
  }

  return (
    <Container maxWidth="lg">
      <Box textAlign="center" pb={2}>
        <TF variant="h5" bold paragraph>
          Here is what our customers have to say
        </TF>

        <Box textAlign="center" mt={3}>
          <Grid container spacing={3}>
            {!isSmall ? (
              items.map((review) => (
                <Grid key={review.name} item sm={4}>
                  <ReviewView
                    name={review.name}
                    stars={review.stars}
                    description={review.description}
                    timestamp={review.timestamp}
                  />
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Slider {...sliderSettings} autoplay={true} autoplaySpeed={5000}>
                  {items.map((review) => (
                    <ReviewView
                      key={review.name}
                      name={review.name}
                      stars={review.stars}
                      description={review.description}
                      timestamp={review.timestamp}
                    />
                  ))}
                </Slider>
              </Grid>
            )}

            <Grid item xs={12}>
              <Box width={isSmall ? "100%" : "30%"} mx="auto">
                <Button
                  target="_blank"
                  href="https://www.google.com/search?q=swyft+energy#lrd=0x484491de0e84a343:0x3beb06c85e8b977f,1"
                  color="secondary"
                  variant="contained"
                  fullWidth
                >
                  View More
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

interface Props {
  type?: EQuoteType;
  support?: boolean;
}
